module.exports = __webpack_public_path__ + "static/media/Logo.abfbba00.png";